import { createFileRoute, redirect } from '@tanstack/react-router'
import { landingPath } from '@/lib/account'

// Spec 002: the bare address takes each person to their side of MySerbisyo.
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    throw redirect({ to: await landingPath() })
  },
})
